<template>
<div>
    <div v-if="!isAuthorized">
        You cannot access this website
    </div>
    <div v-if="isAuthorized && !isRendering" class="app">
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
            <div class="navbar-brand"> JohnStonemart </div>
            <button class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item active">
                    <a class="nav-link text-white pointer" v-if="isAuthenticated&&this.user.role == 'admin'" @click="changeView('Management')"><strong> Management </strong></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-white pointer" v-if="!isAuthenticated" @click="changeView('Login')"><strong> Login </strong></a>
                </li>
            </ul>
                <a class="nav-link text-white" v-if="isAuthenticated"> 
                    <strong> Hi {{ this.user.name }} </strong>
                    <div class="admin-badge text-primary text-center" v-if="user.role == 'admin'"> Admin </div>
                </a>
                <b-button class="nav-link text-white pointer" size='sm' variant="danger" v-if="isAuthenticated" @click="logout()"><strong> Log out </strong></b-button>
            </div>
        </nav>
        <div class="container py-4">
            <component 
            id=“component” 
            v-bind:user="user"
            v-bind:is="component" 
            v-bind:selectedEvent="selectedEvent"
            v-on:showEventDetails="showEventDetails($event)"
            v-on:authentication="authenticated($event)" 
            v-on:updateUserInfo="updateUserInfo($event)" 
            v-on:addEvent="changeView('AddEvent')"
            v-on:backToEvents="changeView($event)"/>
        </div>
    </div>
</div>
</template>
<script>
import Login from './views/Login'
import Management from './views/Management'
import firebase from 'firebase'

export default {
  data() {
    return {
      isRendingFinished: false,
      isAuthenticated: null,
      user: {
          email: '',
          username: '',
          role: false
      },
      component: 'Login',
      selectedEvent: Object,
      isAuthorized: true,
      isRendering: false
    }
  },
  components: {
      Login,
      Management
  },
  created() {
    firebase.auth().onAuthStateChanged(snapshot => {
        if (snapshot) {
            //this.isAuthenticated = true;
            console.log('authenticated' + firebase.auth().currentUser.uid);
        } else {
            this.isAuthenticated = false;
            console.log('unauthenticated');
        }
    });
  },
  watch: {
    isAuthenticated(newIsAuthenticated) {
      var self = this;
      this.isRendering = true;

      if (!newIsAuthenticated) {
        this.changeView('Login');
        this.user = {};
      } else {
        var usersRef = firebase.firestore().collection("users");
        var userId = firebase.auth().currentUser.uid;
        var docRef = usersRef.doc(userId);
        docRef.get().then((doc) => {
            if (doc) {
                self.user = doc.data();
                if (self.user.role == 'admin') {
                    self.component = 'Management';
                } else {
                    self.isAuthorized = false;
                }
            } else {
                console.log("No such document!");
            }
            this.isRendering = false;
        }).catch((error) => {
            console.log("Error getting document", error);
            this.isRendering = false;
        });
      }
      this.isRendering = false;
    }
  },
  methods: {
      logout: function() {
        firebase.auth().signOut();
      },
      authenticated: function(result) {
          this.isAuthenticated = result;
      },
      updateUserInfo: function(user) {
          this.user = user;
      },
      changeView: function(view) {
          this.component = view;
      },
      addEvent() {
          this.component = 'AddEvent';
      },
      showEventDetails(event) {
          this.selectedEvent = event;
          this.changeView('EventDetails');
      }
  }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.pointer {
    cursor: pointer;
}

.admin-badge {
      background:white ;
      border-radius: 5px;
      margin-right: auto;
      padding: 0 10px;
      font-weight: bold;
    }
</style>
